import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Hero } from '../components/Hero';
import { PressMarquee } from '../components/PressMarquee';
import { MetricsSection } from '../components/MetricsSection';
import { Reveal } from '../components/Reveal';
import { ImageReveal } from '../components/ImageReveal';
import { WorkCard } from '../components/WorkCard';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { Button } from '../components/Button';
import { projects } from '../data/work';
import { articles } from '../data/insights';
import { images } from '../data/site';
export function Home() {
  const featuredWork = projects.slice(0, 3);
  const featuredArticles = articles.slice(0, 3);
  return <>
      <Hero data-id="element-307" data-mp="3kuqvf96ejtj3" />

      <div className="mt-28 sm:mt-40" data-id="element-308" data-mp="3kv0jusbstsmo">
        <PressMarquee data-id="element-309" data-mp="3owcghht3be4d" />
      </div>

      {/* About preview */}
      <section className="px-6 py-28 sm:px-10 sm:py-40" data-id="element-310" data-mp="3oyylb9oljfiw">
        <div className="mx-auto grid max-w-[92rem] gap-14 lg:grid-cols-12 lg:gap-20" data-id="element-311" data-mp="30vqfmgev1izx">
          <div className="lg:col-span-5" data-id="element-312" data-mp="2vxf3fz13ewej">
            <ImageReveal src={images.heroPortrait} alt="Amoye Henry at work" className="aspect-[4/5] rounded-[2rem] border border-charcoal/[0.07]" parallax={26} data-id="element-313" data-mp="2vyhrlz716kqr" />
          </div>
          <div className="lg:col-span-6 lg:col-start-7 lg:pt-10" data-id="element-314" data-mp="2hyffyupbgnjy">
            <Reveal data-id="element-315" data-mp="2hzqjcteuntaj">
              <p className="eyebrow text-mocha" data-id="element-316" data-mp="2d7gvrk17j5bf">About</p>
            </Reveal>
            <Reveal delay={0.08} data-id="element-317" data-mp="2d5dxydttc7w5">
              <h2 className="mt-6 font-serif text-[2.75rem] font-light leading-[1.02] tracking-[-0.01em] text-charcoal sm:text-[3.75rem]" data-id="element-318" data-mp="287kpfe51f1sp">
                Building what matters.
              </h2>
            </Reveal>
            <div className="mt-10 space-y-7 text-[1.0625rem] leading-[1.8] text-charcoal/70" data-id="element-319" data-mp="1z6e9b66avszz">
              <Reveal delay={0.14} data-id="element-320" data-mp="1u9e1appw4g68">
                <p data-id="element-321" data-mp="1uafqdy3qr36y">
                  I have spent my career on both sides of the table — building
                  companies from nothing, and backing the people who do.
                </p>
              </Reveal>
              <Reveal delay={0.2} data-id="element-322" data-mp="1ojzhqmjeigb3">
                <p data-id="element-323" data-mp="1ancjmgfppk3l">
                  My work sits where entrepreneurship, capital and policy meet:
                  venture building, investing, ecosystem design, and the
                  partnerships that let ambitious ideas reach real markets.
                </p>
              </Reveal>
              <Reveal delay={0.26} data-id="element-324" data-mp="28atali9iaw6r">
                <p data-id="element-325" data-mp="289s13i852hr5">
                  The measure is simple. Did it create opportunity? Did it last?
                </p>
              </Reveal>
            </div>
            <Reveal delay={0.32} data-id="element-326" data-mp="1yjynycscluks">
              <div className="mt-12" data-id="element-327" data-mp="1yj723tojzb7p">
                <Button to="/about" variant="secondary" data-id="element-328" data-mp="1yi5k1594dogh">
                  Read the full story
                </Button>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <MetricsSection data-id="element-329" data-mp="flu316ghsaje" />

      {/* Selected work */}
      <section className="px-6 py-28 sm:px-10 sm:py-40" data-id="element-330" data-mp="fkixb13hkspn">
        <div className="mx-auto max-w-[92rem]" data-id="element-331" data-mp="amz7d3xferhv">
          <Reveal data-id="element-332" data-mp="am7n2p9a4g6w">
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-333" data-mp="akmu342m55b5">
              <div data-id="element-334" data-mp="odmb5ai1n7kt">
                <p className="eyebrow text-mocha" data-id="element-335" data-mp="og8ipa4xpn31">Selected work</p>
                <h2 className="mt-6 max-w-2xl font-serif text-[2.5rem] font-light leading-[1.04] tracking-[-0.01em] text-charcoal sm:text-[3.5rem]" data-id="element-336" data-mp="kdtvyey5a36h">
                  Mandates that changed what a market could do.
                </h2>
              </div>
              <Link to="/work" className="link-underline inline-flex items-center gap-2 text-sm text-charcoal/70 hover:text-charcoal" data-id="element-337" data-mp="5neacz1tgt7s">
                All work <ArrowRightIcon className="h-4 w-4" strokeWidth={1.3} data-id="element-338" data-mp="1h2t6k0m7bh1u" />
              </Link>
            </div>
          </Reveal>

          <div className="mt-16 space-y-20" data-id="element-339" data-mp="1c4hx3qztj8k5">
            <Reveal data-id="element-340" data-mp="1c3ggz83y3vvk">
              <WorkCard project={featuredWork[0]} large data-id="element-341" data-mp="27dwl6pnl9eye" />
            </Reveal>
            <div className="grid gap-16 md:grid-cols-2" data-id="element-342" data-mp="27fzky1ejmmgb">
              {featuredWork.slice(1).map((p, i) => <Reveal key={p.slug} delay={i * 0.1} data-id="element-343" data-mp="2cesyftttydgh" data-mpi={i}>
                  <WorkCard project={p} data-id="element-344" data-mp="2hb9mko114rtk" />
                </Reveal>)}
            </div>
          </div>
        </div>
      </section>

      {/* Speaking teaser */}
      <section className="relative overflow-hidden border-y border-charcoal/[0.08]" data-id="element-345" data-mp="2qdakzo801jwt">
        <ImageReveal src={images.speakingStage} alt="Keynote stage at a global technology summit" className="h-[32rem] w-full sm:h-[40rem]" imgClassName="brightness-[0.62]" parallax={40} data-id="element-346" data-mp="2vbke7ta5yafs" />
        <div className="absolute inset-0 flex items-center px-6 sm:px-10" data-id="element-347" data-mp="3513yn3diyccr">
          <div className="mx-auto w-full max-w-[92rem]" data-id="element-348" data-mp="3a1jbzuxt3juq">
            <Reveal data-id="element-349" data-mp="39yx41u7072bz">
              <p className="eyebrow text-ivory/70" data-id="element-350" data-mp="3e2229kk1whut">Speaking</p>
            </Reveal>
            <Reveal delay={0.1} data-id="element-351" data-mp="12ezz2b3zh10o">
              <blockquote className="mt-7 max-w-3xl font-serif text-[2rem] font-light italic leading-[1.14] tracking-[-0.01em] text-ivory sm:text-[3.5rem]" data-id="element-352" data-mp="12f8arzode0aa">
                “I believe innovation should create opportunity that lasts.”
              </blockquote>
            </Reveal>
            <Reveal delay={0.18} data-id="element-353" data-mp="ofqk1erikcya">
              <div className="mt-12" data-id="element-354" data-mp="ogiegm9dk4mz">
                <Link to="/speaking" className="inline-flex items-center gap-2 rounded-full bg-ivory px-7 py-3.5 text-[0.8125rem] font-medium uppercase tracking-[0.08em] text-charcoal transition-colors duration-500 hover:bg-champagne" data-id="element-355" data-mp="ohjtf1tihb9z">
                  Book Amoye to speak
                </Link>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <TestimonialsSection data-id="element-356" data-mp="24tqh8hyz5ohu" />

      {/* Insights */}
      <section className="border-t border-charcoal/[0.08] px-6 py-28 sm:px-10 sm:py-40" data-id="element-357" data-mp="24vjre78sqqul">
        <div className="mx-auto max-w-[92rem]" data-id="element-358" data-mp="201fivjjvuare">
          <Reveal data-id="element-359" data-mp="3ua2juwlt5fvj">
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-360" data-mp="3ubndmk0asusc">
              <div data-id="element-361" data-mp="27bbfxk66o1c">
                <p className="eyebrow text-mocha" data-id="element-362" data-mp="25qiudhf1f64">Insights</p>
                <h2 className="mt-6 font-serif text-[2.5rem] font-light leading-[1.04] text-charcoal sm:text-[3.5rem]" data-id="element-363" data-mp="3kl13h5bcowh1">
                  Notes from the work.
                </h2>
              </div>
              <Link to="/insights" className="link-underline inline-flex items-center gap-2 text-sm text-charcoal/70 hover:text-charcoal" data-id="element-364" data-mp="3amv2qr1a5wdr">
                All writing <ArrowRightIcon className="h-4 w-4" strokeWidth={1.3} data-id="element-365" data-mp="31m6nxu42brzt" />
              </Link>
            </div>
          </Reveal>

          <div className="mt-16 grid gap-14 md:grid-cols-3" data-id="element-366" data-mp="36k89qmsvi5ez">
            {featuredArticles.map((a, i) => <Reveal key={a.slug} delay={i * 0.1} as="article" data-id="element-367" data-mp="zvv8wfnrsb5j" data-mpi={i}>
                <Link to="/insights" className="group block" data-id="element-368" data-mp="14td7pd82p9zt">
                  <div className="aspect-[3/2] overflow-hidden rounded-[1.5rem] border border-charcoal/[0.07]" data-id="element-369" data-mp="14rkbkrv36862">
                    <img src={a.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.6s] ease-editorial group-hover:scale-[1.05]" data-id="element-370" data-mp="1ev7eu3mxe5jt" />
                  </div>
                  <p className="eyebrow mt-6 text-charcoal/40" data-id="element-371" data-mp="1xo2yc4venr6x">
                    {a.category} · {a.readTime}
                  </p>
                  <h3 className="mt-3 font-serif text-[1.5rem] font-light leading-[1.16] text-charcoal" data-id="element-372" data-mp="1snx36epxfmk3">
                    {a.title}
                  </h3>
                </Link>
              </Reveal>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-373" data-mp="caqh0oogjmoh" />
    </>;
}